import SubscribeForm from "@/components/feature/SubscribeForm";
import { testimonials } from "@/mocks/guaData";

export default function HomeSubscribe() {
  return (
    <section className="w-full bg-primary-50" aria-labelledby="subscribe-title">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-12 md:px-8 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="w-full lg:col-span-7">
            <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-primary-600">
              <span className="h-px w-6 bg-primary-400" />
              每日盘点
            </p>
            <h2
              id="subscribe-title"
              className="heading-font mt-2 text-2xl font-black leading-tight text-foreground-950 md:text-3xl"
            >
              一次订阅，早上就把昨天的瓜补齐
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              每个工作日早上一封邮件，包含前一天的榜单变化、重点事件的脉络更新，以及值得留意的争议点。
              没有推送轰炸，不想看随时退订。
            </p>
            <div className="relative mt-6 max-w-2xl rounded-lg border border-primary-200 bg-background-50 p-4 md:p-5">
              <SubscribeForm />
            </div>
            <p className="mt-3 text-xs text-foreground-500">
              我们只发送盘点内容，不会把你的邮箱用于其他用途。
            </p>
          </div>

          <div className="w-full lg:col-span-5">
            <h3 className="heading-font text-base font-bold text-foreground-950">读者怎么说</h3>
            <div className="mt-4 flex flex-col gap-4">
              {testimonials.map((item) => (
                <figure
                  key={item.name}
                  className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5"
                >
                  <blockquote className="text-sm leading-relaxed text-foreground-700">
                    “{item.text}”
                  </blockquote>
                  <figcaption className="mt-3 flex items-center gap-3">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 text-sm font-bold text-secondary-800">
                      {item.initial}
                    </span>
                    <span className="flex flex-col">
                      <span className="text-sm font-semibold text-foreground-900">{item.name}</span>
                      <span className="text-xs text-foreground-500">{item.role}</span>
                    </span>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}